import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import GridSyncService from "app/services/gridSync/gridSync.service";
import ObjectCopyService from "external-services/object-copy-service/index";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import PouchActions, {PouchDocType} from 'app/actions/pouch.actions';

const NS = 'SectionsCtrl';

export default function SectionsCtrl(
  $rootScope, $scope, $log, $mdDialog, $mdToast, $filter, $state, $window, unregister
) {
  "ngInject";
  var vm = this;

  //-- define public properties
  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SAVED = 2;
  vm.ERROR = 3;
  vm.state = vm.LOADING;
  //-- define public methods
  vm.save = save;
  vm.addSection = addSection;
  vm.plan = plan;
  vm.showPlan = $window.config.plan.sections;
  vm.tryAgain = tryAgain;
  vm.moveUp = moveUp;
  vm.moveDown = moveDown;
  vm.updateSectionName = updateSectionName;
  vm.updateMaxOccupancy = updateMaxOccupancy;

  //-- listen
  var listeners = [];
  // listeners.push($rootScope.$on('pouch-synced-doctype-section', getSections));
  listeners.push(PouchActions.handlePouchSyncedDoctype(PouchDocType.section, () => getSections()));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  getSections();
  getGeneralSettings();

  function getSections() {
    SectionLookupService.getSections().then(function (sections) {
      vm.sections = $filter('orderBy')(sections, 'order');
      vm.sections = SectionLookupService.setOrderForSection(vm.sections);
      // CLI-165: keep a baseline copy so we can detect which sections actually
      // changed on save and only notify the Grid Sync API for those.
      vm.originalSections = ObjectCopyService.angularSafeCopy(vm.sections);
      vm.state = vm.ENTER;
    }).catch(function (err) {
      $log.error('sections failed to load', err);
    });
  }

  function getGeneralSettings() {
    GeneralSettingsService.get().then(function (settings) {
      vm.generalSettings = settings;
    });
  }

  function moveUp(index, section) {
    var sectionAbove = vm.sections[index - 1];
    var aboveOrder = sectionAbove.order;
    sectionAbove.order = section.order;
    section.order = aboveOrder;
    vm.sections = $filter('orderBy')(vm.sections, 'order');

  }

  function moveDown(index, section) {
    var sectionBelow = vm.sections[index + 1];
    var belowOrder = sectionBelow.order;
    sectionBelow.order = section.order;
    section.order = belowOrder;
    vm.sections = $filter('orderBy')(vm.sections, 'order');

  }

  function tryAgain() {
    vm.state = vm.ENTER;
  }

  function save(isValid) {
    // temporary commented out to allow saving Section names
    const isMaxOccupancyValid = vm.generalSettings.enableMaxOccupancy ? checkForMaxOccupancyValidation(vm.sections) : true;
    if (isValid && isMaxOccupancyValid) {
      vm.state = vm.LOADING;
      SectionLookupService.saveSections(vm.sections).then(function () {
        // CLI-165: only notify the Grid Sync API for sections that actually changed
        vm.sections.forEach(function (section) {
          if (!section._id) {
            return;
          }
          var original = (vm.originalSections || []).find(function (orig) {
            return orig._id === section._id;
          });
          if (!original || !angular.equals(section, original)) {
            GridSyncService.sectionEdited(section._id);
          }
        });
        // refresh the baseline so a subsequent save compares against the latest
        vm.originalSections = ObjectCopyService.angularSafeCopy(vm.sections);
        vm.state = vm.ENTER;
        $mdToast.show(
          $mdToast.simple()
            .content('Sections Saved')
            .position('bottom right')
            .theme('saved')
            .hideDelay(3000)
        );
      }).catch(function () {
        vm.state = vm.ERROR;
      });
    } else {
      vm.displayErrors = true;
    }
  }

  function checkForMaxOccupancyValidation(sections) {
    const isNotValid = sections.some(val => {
      if (!isNaN(val.maxOccupancy) || val.maxOccupancy !== null) {
        return (val.maxOccupancy < 0 || (val.maxOccupancy > 0 && !Number.isInteger(val.maxOccupancy)))
      } else {
        return false
      }
    })
    if(isNotValid){
      $mdToast.show(
        $mdToast.simple()
          .content('Please enter a correct value')
          .position('bottom right')
          .theme('error')
          .hideDelay(3000)
      );
    }
    return !isNotValid;
  }

  function addSection(evt) {
    $mdDialog.show({
      controller: 'NewSectionCtrl',
      controllerAs: 'vm',
      clickOutsideToClose: true,
      locals: {
        tag: null
      },
      templateUrl: 'app/settings/sections/newSection.html',
      targetEvent: evt
    });
  }

  function plan(evt) {
    evt.stopPropagation();
    $state.go('settings.sections.plan');
  }

  function updateSectionName(eventVal, index) {
    if (eventVal) {
      vm.sections[index] = {...vm.sections[index], name: eventVal};
    }
  }

  function updateMaxOccupancy(eventVal, index) {
    vm.sections[index] = {...vm.sections[index], maxOccupancy: eventVal};
  }
}
